"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = exports.useDeckCheatSheet = void 0;
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../helpers");
var DeckProvider_1 = require("../DeckProvider");
var _a = __read(helpers_1.createContext(), 2), hook = _a[0], Provider = _a[1];
var DeckCheatSheetProvider = function (_a) {
    var children = _a.children;
    var deck = DeckProvider_1.useDeck();
    var _b = __read(react_1.useState([]), 2), summaries = _b[0], setSummaries = _b[1];
    var _c = __read(react_1.useState(false), 2), subscribe = _c[0], setSubscribe = _c[1];
    var _d = __read(react_1.useState(true), 2), loading = _d[0], setLoading = _d[1];
    react_1.useEffect(function () {
        if (subscribe) {
            deck.ref.collection('cheat-sheet').onSnapshot(function (snapshot) {
                setSummaries(snapshot.docs.map(function (doc) { return doc.data(); }));
                setLoading(false);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subscribe]);
    return (react_1.default.createElement(Provider, { value: {
            loading: loading,
            subscribe: function () { return setSubscribe(true); },
            summaries: summaries,
        } }, children));
};
exports.useDeckCheatSheet = hook;
exports.ContextProvider = Provider;
exports.default = DeckCheatSheetProvider;
//# sourceMappingURL=DeckCheatSheetProvider.js.map